/**
 * 其他 内容
 */
export default {
  //构建内容
  build() {
    return [
      {
        title: 'other-ads-platform',//广告平台
        content: [{
          name: 'other-google-ads',//Google广告
          id: 1,
          link: 'https://ads.google.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/google_ads_logo.png')
        // },{        ----不做 亚马逊站内 广告！！！
        //   name: 'other-amazon-ads',//亚马逊广告
        //   id: 2,
        //   link: 'https://advertising.amazon.com',
        //   logoColor: '#FFFFFF',
        //   img: require('@/assets/logo/amazon_ads_logo.png')
        },{
          name: 'other-tiktok-ads',//TikTok广告
          id: 3,
          link: 'https://ads.tiktok.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/tiktok_ads_logo.png')
        },{
          name: 'other-facebook-ads',//Facebook广告管理
          id: 4,
          link: 'https://www.facebook.com/adsmanager',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/facebook_ads_logo.png')
        }]
      },
      {
        title: 'other-commonTools',//"常用工具",
        content: [{
          name: 'other-online-tools',//在线工具
          id: 2,
          link: 'https://tool.lu',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/online_tools_logo.png'),
          isDeveloper: true
        }, {
          name: 'other-tool',//程序员在线工具
          id: 3,
          link: 'http://www.ofmonkey.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/1602660161525.png'),
          isDeveloper: true
        }, {
          name: 'other-json',//'JSON在线编辑器',
          id: 4,
          link: 'https://qqe2.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/sds2323.png'),
          isDeveloper: true
        }, {
          name: 'other-img-del-bottom',//在线图片去底
          id: 5,
          link: 'https://www.aigei.com/bgremover',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/aigei_logo.png'),
          isDeveloper: true
        }, {
          name: 'other-img-to-ico',//在线生成ico图标
          id: 6,
          link: 'http://www.ico51.cn',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/to_ico_logo.png'),
          isDeveloper: true
        }, {
          name: 'other-docker-hub',//Docker hub仓库
          id: 7,
          link: 'https://hub.docker.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/docker_hub_logo.jpg'),
          isDeveloper: true
        }, {
          name: 'other-aliMaven',//'阿里Maven仓库',
          id: 8,
          link: 'https://maven.aliyun.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/1609208238547.png'),
          isDeveloper: true
        }, {
          name: 'other-apacheMaven',//'Apache Maven仓库',
          id: 9,
          link: 'http://repository.apache.org/content/groups/snapshots',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/322323.png'),
          isDeveloper: true
        }, {
          name: 'other-msdn',//MSDN工具站
          id: 10,
          link: 'https://msdn.itellyou.cn',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/msdn_logo.png')
        }, {
          name: 'other-google-trans',//Google翻译
          id: 11,
          link: 'https://translate.google.cn',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/gg_fanyi_logo.png')
        }, {
          name: 'other-youdao-trans',//有道翻译
          id: 12,
          link: 'https://fanyi.youdao.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/youdao_fanyi_logo.png')
        }, {
          name: 'other-baidu-trans',//百度翻译
          id: 13,
          link: 'https://fanyi.baidu.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/baidu_fanyi_logo.png')
        }, {
          name: 'other-ali-iconfont',//阿里巴巴矢量图标库
          id: 14,
          link: 'https://www.iconfont.cn',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/ali_iconfont.png')
        }]
      },
      {
        title: 'other-servicePlatform',//"服务平台",
        content: [{
          name: 'other-aliCloud',//'阿里云',
          id: 1,
          link: 'https://www.aliyun.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/aliyun_logo.png'),
          isDeveloper: true
        }]
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/content/content_other.js